export const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

// export const getAddressFromCoords = async (lat, lng) => {
//   const response = await fetch(
//     `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`,
//     {
//       headers: {
//         'User-Agent': 'MyReactApp/1.0 (me@example.com)',
//       },
//     }
//   );
//   const data = await response.json();
//   return data.display_name || 'Unknown address';
// };

// export const getAddressFromCoords = async (lat, lng) => {
//   try {
//     const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; // replace with your key

//     const response = await fetch(
//       `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
//     );

//     const data = await response.json();

//     if (data.status === "OK" && data.results.length > 0) {
//       // The first result is usually the most accurate
//       return data.results[0].formatted_address;
//     } else {
//       return "Unknown address";
//     }
//   } catch (error) {
//     console.error("Error fetching address:", error);
//     return "Error fetching address";
//   }
// };

export const getAddressFromCoords = (lat, lng) => {
  return new Promise((resolve, reject) => {
    // Ensure Google Maps script is loaded
    if (!window?.google || !window?.google.maps) {
      console.error('Google Maps API not loaded.');
      return resolve('Unknown address');
    }

    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat, lng };

    geocoder?.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK' && results && results[0]) {
        resolve(results[0].formatted_address);
      } else {
        console.warn('Geocoder failed:', status);
        resolve('Unknown address');
      }
    });
  });
};


export const isBase64Image = (value) =>
  typeof value === 'string' && value.startsWith('data:image');

export const base64ToFile = (base64, filename = 'camera.jpg') => {
  const [meta, data] = base64.split(',');
  const mime = meta.match(/:(.*?);/)[1];
  const binary = atob(data);
  const array = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }

  return new File([array], filename, { type: mime });
};

export const resizeImage = (file, maxWidth = 1280, quality = 0.8) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    const img = new Image();

    reader.onload = (e) => (img.src = e.target.result);
    reader.readAsDataURL(file);

    img.onload = () => {
      const scale = Math.min(maxWidth / img.width, 1);
      const canvas = document.createElement('canvas');

      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) =>
          resolve(
            new File([blob], 'upload.jpg', {
              type: 'image/jpeg',
            })
          ),
        'image/jpeg',
        quality
      );
    };
  });
